/**
 * How big a counted thing is drawn — coins, cards, anything else that is a
 * number with a mark beside it.
 *
 * One scale for all of them, in one file, because the whole point of drawing a
 * count rather than spelling it out is that the reader meets the **same shape**
 * everywhere. Two components each picking their own sizes is how a row ends up
 * with a 16px coin beside a 24px card.
 */
export type CounterSize =
  /** A one-line summary — a collapsed side, a 48px row. */
  | "tight"
  /** A heading on a phone or a laptop, read at arm's length. */
  | "near"
  /** A television, read at three metres. */
  | "room";

/** The mark's edge length in pixels. */
export const COUNTER_ICON: Record<CounterSize, number> = {
  tight: 16,
  near: 24,
  room: 40,
};

/** The gap and type size that go with it. */
export const COUNTER_TEXT: Record<CounterSize, string> = {
  tight: "gap-1 text-sm",
  near: "gap-2 text-lg",
  room: "gap-3 text-3xl",
};
